import { combineReducers } from "redux";
import importObject from './reducers/import_object';
import runRecords from './reducers/run_records';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  importObject,
  paths: nullReducer,
  runRecords,
  static: nullReducer,
  ui
});
